import { render, staticRenderFns } from "./ClubTitleLayout.vue?vue&type=template&id=53d37a08&"
import script from "./ClubTitleLayout.vue?vue&type=script&lang=ts&"
export * from "./ClubTitleLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ClubTitleLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports